import React from 'react';

/**
 * The line under a page title that says how much is on the page.
 *
 * Convention (`docs/design-decisions.md`, "Seitentitel"): the title names the
 * area ("Buchungsübersicht"), the subtitle carries the count with its plural
 * ("14 Buchungen"). Counts never go in the title itself — a heading that reads
 * "5 / 5 Standorte" is a number wearing a title's clothes, and it cannot be
 * used as a landmark.
 *
 * Extracted because four overview pages needed the same two Tailwind classes
 * and only one of them had them.
 */
const PageSubtitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <p className={'text-sm text-foreground/60'}>{children}</p>
);

export default PageSubtitle;
